<div class="app-isf-ocr-quick-fix-ship-to-details">
  <div class="app-isf-ocr-quick-fix-ship-to-details__header">
    <div class="app-isf-ocr-quick-fix-ship-to-details__header__left">
      <p class="app-isf-ocr-quick-fix-ship-to-details__header__title">
        {{ "ENTITY.SHIP_TO" | translate | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'INFO.ST.SUB_TITLE' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <div class="app-isf-ocr-quick-fix-ship-to-details__row">
    <p class="app-isf-ocr-quick-fix-ship-to-details__text m-0">
      {{ "INFO.ST.SUB_TITLE" | translate }}
    </p>
    <p class="app-isf-ocr-quick-fix-ship-to-details__hint-text">{{ "LABELS.USE_PREV_INFO" | translate }}</p>
  </div>

  <ng-container *ngIf="isEditMode">
    <div *ngFor="let isfEntity of possibleIsfEntities; let inx = index" class="app-isf-ocr-quick-fix-ship-to-details__row">
      <app-entity-unify-card
        [entity]="isfEntity"
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.SHIP_TO"
        [selectedValueControl]="formGroup.get('id')"
        [labelOverride]="getEntityOverrideLabel(isfEntity)"
        [isDesktop]="isDesktop"
      ></app-entity-unify-card>
    </div>
  </ng-container>

  <div class="app-isf-ocr-quick-fix-ship-to-details__row">
    <app-section-form-block-layout
      *ngIf="!!shipToFields"
      [formGroup]="formGroup"
      [editBlockDescription]="(!!importer || !!consignee || !!buyer) && isEditMode ? 'LABELS.OR_ADD_DETAILS' : ''"
      [fields]="shipToFields"
      [displayFields]="shipToDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(shipToFields, formGroup)"
      [isHideBorder]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.BUYER"
        [errors]="formErrors"
        [isShowState]="true"
        [isShowCountry]="true"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-isf-ocr-quick-fix-ship-to-details__hr" />

    <div class="app-isf-ocr-quick-fix-ship-to-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
